export default "__VITE_ASSET__Dnuzb5rn__"